import * as React from 'react'

interface TitleProps {
  size?: '40px' | '32px' | '48px' | '24px' | '20px' | '16px'
  style?: React.CSSProperties
}

const Title: React.SFC<TitleProps> = ({ children, size = '48px', style }) => {
  return (
    <div
      style={{
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'bold',
        lineHeight: 'normal',
        fontSize: size,
        color: 'inherit',
        ...style,
      }}
    >
      {children}
    </div>
  )
}

export default Title



// WEBPACK FOOTER //
// ./src/components/titlte/Title.tsx